import React from "react";
import { Button, Space, Typography } from "antd";
import dayjs from "dayjs";

const { Paragraph } = Typography;

interface EnrolmentPromptProps {
	graceUntil: string | null;
	onSetUp: () => void;
	onLater: () => void;
}

// A staff sign-in during the 7-day grace (contract §6.3): skippable now, enforced by identity once it lapses.
const EnrolmentPrompt: React.FC<EnrolmentPromptProps> = ({ graceUntil, onSetUp, onLater }) => (
	<div className="login-form" data-testid="login-enrol-prompt">
		<Paragraph className="login-step-intro">
			Staff accounts need an authenticator app or a passkey as a second step at sign-in.
			{graceUntil ? (
				<>
					{" "}
					You can skip this until <strong data-testid="login-enrol-deadline">{dayjs(graceUntil).format("D MMM YYYY, h:mm a")}</strong>; after
					that you will have to set it up before you can continue.
				</>
			) : null}
		</Paragraph>
		<Space direction="vertical" style={{ width: "100%" }} size="middle">
			<Button data-testid="login-enrol-now" type="primary" block size="large" onClick={onSetUp}>
				Set up now
			</Button>
			<Button data-testid="login-enrol-later" block size="large" onClick={onLater}>
				Remind me next time
			</Button>
		</Space>
	</div>
);

export default EnrolmentPrompt;
